<template>
  <div>
    <v-form
      :model="valid" ref="formReport"
      lazy-validation
    >
      <v-card
        v-if="token==='nowebview'"
        class="mx-auto"
        outlined
      >
        <v-card-title>
          <v-row>
            <v-spacer></v-spacer>
            <v-col cols="12" md="4" sm="6" style="padding-bottom: 0">
              <v-autocomplete
                outlined
                dense
                v-model="params.client_id"
                :items="clientListOptRep"
                auto-select-first
                item-text="name"
                item-value="id"
                :label="$t('member')"
                :placeholder="$t('all')"
                clearable
                required
                :search-input.sync="searchClient"
              >
                <template v-slot:selection="{ item }">
                  {{ item.name }}
                </template>
                <template v-slot:item="{ item }">
                  {{ item.name }} : {{ item.mobile }}
                </template>
              </v-autocomplete>
            </v-col>

            <v-col cols="12" md="2" sm="6" style="padding-bottom: 0">
              <v-autocomplete
                outlined
                dense
                v-model="params.category_id"
                :items="categoryListOptRep"
                auto-select-first
                item-text="name"
                item-value="id"
                :label="$t('category')"
                :placeholder="$t('all')"
                clearable
                required
              >
                <template v-slot:selection="{ item }">
                  {{ item.name }}
                </template>
                <template v-slot:item="{ item }">
                  {{ item.name }}
                </template>
              </v-autocomplete>
            </v-col>

            <v-col cols="12" md="2" sm="6" style="padding-bottom: 0">
              <v-autocomplete
                outlined
                dense
                v-model="params.product_id"
                :items="listProductByCategory"
                auto-select-first
                item-text="name"
                item-value="id"
                :label="$t('product')"
                :placeholder="$t('all')"
                clearable
                required
              >
                <template v-slot:selection="{ item }">
                  {{ item.name }}
                </template>
                <template v-slot:item="{ item }">
                  {{ item.name }}
                </template>
              </v-autocomplete>
            </v-col>

            <v-col cols="12" md="2" sm="6" style="padding-bottom: 0">
              <v-text-field
                outlined
                dense
                v-model="params.lessThanOrEqualQty"
                :label="$t('lessThanOrEqualQty')"
                clearable
                type="number"
                :placeholder="$t('lessThanOrEqualQty')"
              ></v-text-field>
            </v-col>


            <v-col cols="12" md="2" sm="12" style="padding-bottom: 0">
              <v-spacer v-if="$vuetify.breakpoint.mobile"></v-spacer>
               <v-btn class="mr-6" dark color="blue-grey" elevation="2" outlined text @click="handleRun('nowebview')" :loading="loadingReport">
                  <v-icon class="mr-1"> mdi-magnify </v-icon>
              </v-btn>

              <v-btn @click="exportExcel('exportExcel')" outlined>
                <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="26" height="26" viewBox="0 0 172 172" style=" fill:#000000;"><g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,172v-172h172v172z" fill="none"></path><g fill="#000000"><path d="M24.08,6.88v158.24h104.22125l-5.85203,-6.88h-91.48922v-144.48h65.36v44.66625h44.72v41.33375h6.88v-46.09735l-0.88015,-0.88015c-0.12384,-0.15136 -0.26193,-0.28928 -0.40985,-0.41656l-45.49265,-45.48594zM103.2,18.57734l32.9689,33.02266h-32.9689zM58.97719,65.36l18.12047,30.96l-19.78,30.96h16.56844l10.77015,-19.98156c0.74992,-1.92984 1.23813,-3.40447 1.44453,-4.34703h0.1075c0.42656,2.01928 0.84393,3.38883 1.24297,4.13875l10.76344,20.19656h16.46766l-19.05438,-31.27578l18.53703,-30.65094h-15.53375l-9.83625,18.32875c-0.946,2.39424 -1.61772,4.28522 -1.9686,5.48922h-0.10078c-0.54352,-2.01928 -1.16949,-3.81894 -1.86781,-5.28094l-8.90235,-18.53703zM130.72,106.64v30.96h-17.2l29.22656,34.4l29.25344,-34.4h-17.2v-30.96zM137.6,113.52h10.32v30.96h8.94265l-14.11609,17.2l-14.08922,-17.2h8.94265z"></path></g></g></svg>
              </v-btn>
            </v-col>

          </v-row>
        </v-card-title>

        
      </v-card>
    </v-form>

    <div id="section-to-print">
      <v-row type="flex" class="row-bg" justify="center">
        <h3>{{ $t("stockEndingReport") }}</h3>
        <v-col style="padding: 0px !important;" cols="12" md="12" sm="12"></v-col>

        <v-col sm="6" md="6" lg="6" xs="12" :cols="$vuetify.breakpoint.mobile? '12' : '6'" style="text-align: left">
          {{ $t('date') }} ៖ {{ date }}
        </v-col>
        <v-col sm="6" md="6" lg="6" xs="12" :cols="$vuetify.breakpoint.mobile? '12' : '6'" v-if="token==='nowebview'"
               :style="$vuetify.breakpoint.mobile ? 'padding-top: 0px !important;' :''">
          {{ $t('member') }} ៖ {{ memberName || $t('all') }}
        </v-col>
        <v-col style="padding: 0px !important;" cols="6" md="6" sm="6"></v-col>


        <v-col cols="12" style="overflow-x: auto;display: block;white-space: nowrap;" id="exportExcel">
          <table class="report" v-for="(docClient,k) in dataList" :key="k">
            <thead v-if="k===0">
            <tr>
              <th>{{ $t("n0") }}</th>
              <th>{{ $t("item") }}</th>
              <th>{{ $t("qty") }}</th>
              <th style="text-align: right">{{ $t("cost") }}</th>
              <th style="text-align: right">{{ $t("amount") }}</th>
            </tr>
            </thead>

            <tbody>
            <tr v-if="!!docClient && docClient.stock.length>0">
              <th colspan="5" style="text-align: left">{{ k + 1 }} - {{ docClient.name }}</th>
            </tr>
            <tr v-for="(doc,j) in docClient.stock" :key="j">
              <td style="text-align: center">{{ j + 1 }}</td>
              <td>{{ doc.sku }} : {{ doc.product_name }}</td>
              <td style="text-align: center">{{ doc.qty | formatNumber }} {{ doc.unit_name }}</td>
              <td style="text-align: right">{{
                  doc.cost |
                      formatNumber
                }}{{ getCurrencySymbol(doc.currency_code) }}
              </td>
              <td style="text-align: right">{{
                  parseFloat(doc.qty) * parseFloat(doc.cost) |
                      formatNumber
                }}{{ getCurrencySymbol(doc.currency_code) }}
              </td>
            </tr>
            </tbody>

            <tbody v-for="(docClient,i) in docClient.client" :key="i">
            <tr v-if="!!docClient && docClient.stock.length>0">
              <th colspan="5" style="text-align: left;padding-left: 50px !important;">{{ i + 1 }} - {{
                  docClient.name
                }}
              </th>
            </tr>
            <tr v-for="(doc,j) in docClient.stock" :key="j">
              <td style="text-align: right">{{ j + 1 }}</td>
              <td style="padding-left: 50px!important;">{{ doc.sku }} : {{ doc.product_name }}</td>
              <td style="text-align: center">{{ doc.qty | formatNumber }} {{ doc.unit_name }}</td>
              <td style="text-align: right">{{
                  doc.cost |
                      formatNumber
                }}{{ getCurrencySymbol(doc.currency_code) }}
              </td>
              <td style="text-align: right">{{
                  parseFloat(doc.qty) * parseFloat(doc.cost) |
                      formatNumber
                }}{{ getCurrencySymbol(doc.currency_code) }}
              </td>
            </tr>
            </tbody>
          </table>
        </v-col>
      </v-row>

    </div>


  </div>

</template>

<script>
import ValidatorMixin from "../../../mixins/validatorMixin";
import OptionDataMixin from "../../../mixins/optionDataMixin";
import ReportDataMixin from "../../../mixins/reportDataMixin";
import moment from "moment";
import {provider} from "../../../service/provider"
import axios from "axios";

export default {
  components: {},
  mixins: [ValidatorMixin, OptionDataMixin, ReportDataMixin],
  data() {
    return {
      valid: false,
      loadingReport: false,
      searchClient: "",
      params: {
        lessThanOrEqualQty: "",
        client_id: "",
        category_id: "",
        product_id: ""
      },
      date: moment().format("DD/MM/YYYY"),
      dataList: [],
      vendorData: [],
      memberName: "",
      token: ""
    }
  },
  methods: {
    handlePrint(event) {
      event.preventDefault();
      window.print();
    },
    handleRun() {
      let vm = this;
      vm.loadingReport = true;
      if (vm.$refs.formReport.validate()) {
        let url = provider.baseURL + provider.getStockSupplierEndingReport;
        return new Promise((resolve, reject) => {
          axios.post(url, vm.params, {headers: {Authorization: vm.token === "nowebview" ? localStorage.token : vm.token}}).then(
              res => {
                if (res.data.response && res.data.response.code === 200) {
                  resolve(res.data.data);
                  vm.loadingReport = false;
                  vm.dataList = res.data.data.client || [];
                  vm.vendorData = res.data.data || {};
                } else {
                  vm.loadingReport = false;
                }
              },
              error => {
                reject(error);
              }
          );
        });

      }
    },
    fetchProductOpt(val) {
      let vm = this;
      vm.fetchProduct(val, vm.params.category_id, "", "", "", "");
    }
  },
  watch: {
    searchClient(val) {
      let vm = this;
      val && vm.fetchClientOption(val);
    },
    searchProduct(val) {
      let vm = this;
      vm.fetchProductOpt(val);
    },
    "params.category_id"(id){
      this.fetchProductByCategory(id, this.token)
    },
  },
  computed: {
    userDoc() {
      return true;
      //return this.$store.state.userDoc;
    },
  },
  created() {
    let vm = this;
    
    //vm.params.client_id=localStorage.contact_id;
    let token = vm.$route.params.token;
    vm.token  = token;
    vm.fetchCategoryOptionRep();
    vm.fetchContactOptionRep();
    setTimeout(function () {
      if (localStorage.type !== "employee") {
        vm.handleRun();
      }
    }, 300)

  }
}
</script>